
import React, { useState, useEffect } from "react";
import { RecoilRoot } from "recoil";
import "./App.css";
import Intro from './components/Intro';
import Home from "./components/Home";
import Login from "./components/Login";
import Buy from "./components/Buy";
import Book from "./components/Book";
import RegisterMain from "./components/RegisterMain";
import RegisterForm from "./components/RegisterForm";
import Mypage from "./components/Mypage";
// import ProfileCoupon from "./components/ProfileLoggedIn/ProfileLoggedCoupon";
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import Test from "./components/Test";
import Test1 from "./components/Test1";
import TestLogin from "./components/TestLogin";
import More from './components/More';
import Notification from './components/Notification';
import News from './components/News';
import Center from './components/Center';
import TestReg from './components/TestRegister';
import RegisterConfirm from "./components/RegisterConfirm";
import TestWebview from "./components/TestWebview";
import TestCoupon from "./components/TestCoupon";
import Ready from './components/Ready';
import ReservationTeacher from './components/ReservationTeacher';
import './App.css';
import HomeLevel from "./components/HomeLevel";
import HomeHeartPoint from "./components/HomeHeartPoint";
import HomeClassPoint from "./components/HomeClassPoint";
import BuyDescription from './components/BuyLoggedInDescription'
import Test2 from './components/Test2';
import Test3 from './components/Test3';
import Test4 from './components/Test4';
import Test5 from './components/Test5';
import Test6 from "./components/Test6";
import CouponRefund from './components/CouponRefund';
import CouponReturn from './components/CouponReturn';
import CouponPause from './components/CouponPause';
import HelpCouponCode from "./components/HelpCouponCode";
import Privacy from "./components/Privacy";
import PhotoZone from "./components/PhotoZone";

function App() {

  return (
    <RecoilRoot>
      <Router>
        <Switch>
          <Route exact path="/" component={Intro} />
          {/* <Route exact path="/intro" component={Intro} /> */}
          <Route path="/home" component={Home} />
          <Route path="/login" component={Login} />          
          <Route path="/buy" component={Buy} />
          <Route path="/book" component={Book} />
          <Route path="/register" component={RegisterMain} />
          <Route path="/regform" component={RegisterForm} />
          <Route path="/mypage" component={Mypage} />  
          <Route path="/test_login" component={TestLogin} />
          <Route path="/more" component={More} />          
          <Route path="/notification" component={Notification} />
          <Route path="/news" component={News} />
          <Route path="/center" component={Center} />
          <Route path="/test_reg" component={TestReg} />
          <Route path="/regconfirm" component={RegisterConfirm} />
          <Route path='/ready' component={Ready} />
          <Route path="/test_webview" component={TestWebview} />
          <Route path="/test_coupon" component={TestCoupon} />
          <Route path='/homelevel' component={HomeLevel} />
          <Route path='/test_heart' component={HomeHeartPoint} />
          <Route path='/test_class' component={HomeClassPoint} />
          <Route path='/buy_description' component={BuyDescription} />
          <Route path="/test1" component={Test1} />
          <Route path="/test2" component={Test2} />
          <Route path="/test3" component={Test3} />          
          <Route path="/test4" component={Test4} />          
          <Route path="/test5" component={Test5} />
          <Route path="/test6" component={Test6} />
          <Route path='/refund' component={CouponRefund} />
          <Route path='/return' component={CouponReturn} />
          <Route path='/pause' component={CouponPause} />
          <Route path='/reservation' component={ReservationTeacher} />
          <Route path='/helpcouponcode' component={HelpCouponCode} />
          <Route path='/privacy' component={Privacy} />
          <Route path='/photo_zone' component={PhotoZone} />
        </Switch>
      </Router>
    </RecoilRoot>
  );
}

export default App;
